import { Component, computed, inject, input } from '@angular/core';
import {
  CoreJssProxyModule,
  TextField,
  type LinkField,
  type RichTextField,
} from '@core/jss-proxy';
import { FieldService } from '@core/jss-utils';
import type { IconIcon } from '@essent/current-web';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { NgClass } from '@angular/common';

import { ContactItemComponent } from '../contact-item/contact-item.component';

export type ContactItem = {
  icon: IconIcon | undefined;
  title: TextField | undefined;
  description: TextField | undefined;
  alternativeButton: LinkField | undefined;
  chatButton: TextField | undefined;
};

@Component({
  selector: 'wl-contact-section',
  standalone: true,
  templateUrl: './contact-section.component.html',
  styleUrls: [
    './contact-section.component.ed.scss',
    './contact-section.component.essent.scss',
  ],
  imports: [CoreJssProxyModule, ContactItemComponent, NgClass],
})
export class ContactSectionComponent {
  readonly uid = input.required<string>();
  readonly title = input.required<TextField>();
  readonly introduction = input.required<RichTextField>();
  readonly contactItems = input.required<ContactItem[]>();

  readonly #brand = inject(ENVIRONMENT_CONFIG).brand;
  readonly #fieldService = inject(FieldService);

  readonly showIntroduction = computed(() =>
    this.#fieldService.showTextField(this.introduction())
  );

  readonly isEssent = computed(() => this.#brand === 'essent');
}
